<template>
  <div class="rounded-md h-100p">
    <ChooseProcessDialog v-if="stateValues.showChooseProcessDialog" :leadPartyId="stateValues.leadPartyId" @onCloseChooseProcessDialog="onCloseChooseProcessDialog" @onProcessIdCreated="onProcessIdCreated"></ChooseProcessDialog>
    <SimpleWarningDialog v-if="showDeleteWarn && checkedItems.length > 0" :title="$t('deleteWarn')" :text="stateValues.deleteWarningSubText" :secondaryBtn="true" @onPrimary="onClickCompleteProcess" @onSecondary="onClickCancelProcess" />
    <SimpleWarningDialog v-if="stateValues.showLinkSentDialog" icon="mdi-check-circle-outline" :title="$t('linkSentSuccessfully')" @onPrimary="onCloseLinkSentDialog" />
    <user-card v-if="stateValues.showUserCardDialog" pageType="LeadPartyList" :leadPartyId="stateValues.leadPartyId" :tckn="stateValues.tckn" :processId="stateValues.processId" @onClickOkCustomerCard="onClickOkCustomerCard" />
    <div class="title-wrapper">
      <h1 class="title">
        {{ $t("LeadPartyList") }}
      </h1>
    </div>

    <div class="content-container">
      <div class="content-wrapper">
        <LeadPartyListTable ref="table" :showSelect="stateValues.inDeletingMode" @onClickCustomerCard="onClickCustomerCard" @onClickChooseProcess="onClickChooseProcess" @onCheckedItems="setCheckedItems" />
      </div>
    </div>
    <div class="buttons-wrapper">
      <v-btn v-if="
          stateValues.modeOfDeletion == 'lead' || !stateValues.inDeletingMode
        " class="mr-4" color="black" @click="toggleWarnButtons('lead')">
        <v-icon class="mr-2" color="white">{{ stateValues.inDeletingMode ? "mdi-cancel" : "mdi-trash-can-outline" }}
        </v-icon>
        <span class="color--primary--white">{{ $t(stateValues.inDeletingMode ? "cancel" : "deleteRecords") }}
        </span>
      </v-btn>
      <v-btn v-if="stateValues.inDeletingMode" class="mr-4" color="primary" @click="onClickDeleteButton" :loading="deleteLoading" :disabled="
          deleteLoading ||
            (stateValues.modeOfDeletion == 'process' &&
              checkedItems.length != 1) ||
            (stateValues.modeOfDeletion == 'lead' && checkedItems.length == 0)
        ">
        <v-icon class="mr-2">mdi-check-circle-outline</v-icon>
        {{ $t("complete") }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import AuthAndVideoCall from "./mixin/AuthAndVideoCall";
import { LeadPartyListComponents } from "../../components";

export default {
  mixins: [AuthAndVideoCall],
  components: { ...LeadPartyListComponents }
};
</script>

<style lang="scss" scoped>
$primaryColor: #0032a0;

.h-100p {
  height: 100%;
}

.header-table-divider {
  margin-top: 2%;
}
.btn-new-identity {
  background-color: $primaryColor !important;
  color: white;
}
.v-btn {
  text-transform: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/authandvideocall/LeadPartyList.vue